"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var reportPeriod_1 = require("../../common/helpers/reportPeriod");
var MarketingReportController = /** @class */ (function () {
    function MarketingReportController(ReportsModel, UserService) {
        this.ReportsModel = ReportsModel;
        this.reportData = null;
        this.loading = false;
        this.error = '';
        this.schools = this.locationsOf(UserService.getCurrentUser());
        var _a = (0, reportPeriod_1.defaultReportPeriod)(), start_date = _a.start_date, end_date = _a.end_date;
        this.filters = {
            start_date: start_date,
            end_date: end_date,
            school_ids: this.schools.map(function (school) { return school.id; })
        };
        this.onFilterChange = this.handleFilterChange.bind(this);
        this.fetchData();
    }
    /**
     * Support flags franchise owners one by one: a branch owner shares the franchisor's
     * organisation but may only read its own school, and the API refuses school_ids from them.
     */
    MarketingReportController.prototype.locationsOf = function (user) {
        var isFranchiseOwner = user.franchise_owner === true && user.role.type === 'owner' && !!user.organisation;
        return isFranchiseOwner && user.organisation.schools.length > 1 ? user.organisation.schools : [];
    };
    MarketingReportController.prototype.handleFilterChange = function (newFilters) {
        this.filters = newFilters;
        this.fetchData();
    };
    MarketingReportController.prototype.fetchData = function () {
        var _this = this;
        this.loading = true;
        this.error = '';
        this.ReportsModel.getMarketingReport(this.filters)
            .then(function (response) {
            _this.reportData = response.data;
            _this.loading = false;
        })
            .catch(function () {
            _this.error = 'Failed to load marketing report data.';
            _this.loading = false;
        });
    };
    return MarketingReportController;
}());
MarketingReportController.$inject = ['ReportsModel', 'UserService'];
exports.default = MarketingReportController;
